import { yup } from 'src/common/infra/validations/yup';

export const firstAccessSchema = yup.object().shape({
    newPassword: yup.string().required('field_validations.required'),
    newPasswordConfirmation: yup
        .string()
        .required('field_validations.required')
        .test('password-confirmation', 'field_validations.passwords_match', (field, body) => field === body.parent?.newPassword),
});
